const getters = {
/*  token: state => state.user.token,
  channel:state => state.user.channel,
  avatar: state => state.user.avatar,
  user: state => state.user,*/

}
export default getters
